module.exports = __webpack_public_path__ + "img/span-icon3.08a276c8.png";